import { render } from "./FacturesView.vue?vue&type=template&id=2527e272&scoped=true"
import script from "./FacturesView.vue?vue&type=script&lang=js"
export * from "./FacturesView.vue?vue&type=script&lang=js"

import "./FacturesView.vue?vue&type=style&index=0&id=2527e272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2527e272"]])

export default __exports__